module.exports = __webpack_public_path__ + "e733e0319945098dd13acc3d7985fb70.svg";